// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(rgb(213, 224, 235), rgb(238, 234, 202));
    background-size: cover;
    padding: 20px;
    box-sizing: border-box;
}

.login-card {
    background: rgba(255, 255, 255, 0.9);
    padding: 30px;
    border-radius: 20px;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 400px;
    text-align: center;
    backdrop-filter: blur(10px);
}

.login-header {
    margin-bottom: 20px;
}

.header-text {
    color: #6c757d;
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 10px;
}

.sub-text {
    color: #6c757d;
    font-size: 14px;
}

.login-form {
    text-align: left;
}

.form-group {
    margin-bottom: 15px;
}

.login-form .label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

.login-form .input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ced4da;
    border-radius: 10px;
    box-sizing: border-box;
    font-size: 16px;
}

.login-button {
    background: linear-gradient(to right, #ff7e5f, #feb47b);
    color: #ffffff;
    padding: 12px 20px;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    transition: transform 0.3s ease;
}

.login-footer {
    margin-top: 20px;
    font-size: 14px;
    color: #6c757d;
}

.link {
    color: #ff7e5f;
}

.error-text {
    color: #850101;
}

/* Sidebar Expanded */
.container-xxl {
    display: flex;
}

.container-xxl .content {
    flex-grow: 1;
    margin-left: 250px;
    /* Adjust this based on your sidebar width */
    transition: margin-left 1s ease;
}

/* Sidebar Collapsed (Sidebar Hidden) */
.sidebar-collapsed .content {
    margin-left: 0;
    width: 100%;
    transition: margin-left 1s ease, width 1s ease;
}

.sidebar {
    width: 250px;
    transition: width 1s ease;
}

/* Hide Sidebar */
.sidebar-collapsed .sidebar {
    width: 0;
    overflow: hidden;
    transition: width 1s ease;
}

.padding-4 {
    padding: 2rem 3rem;
    margin-top: 0;
}

nav.navbar.navbar-expand-lg.navbar-dark.bg-color {
    /* background: #FFDED2; */
    background: #ffffff;
}

nav.navbar.navbar-expand-lg.navbar-dark.bg-color ul li a.active {
    color: #00a1d5;
}

nav.navbar.navbar-expand-lg.navbar-dark.bg-color ul li a {
    color: #000000;
    font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mEAAmE;IACnE,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,uDAAuD;IACvD,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA,uCAAuC;AACvC;IACI,cAAc;IACd,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["\r\n.login-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: linear-gradient(rgb(213, 224, 235), rgb(238, 234, 202));\r\n    background-size: cover;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.login-card {\r\n    background: rgba(255, 255, 255, 0.9);\r\n    padding: 30px;\r\n    border-radius: 20px;\r\n    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);\r\n    width: 100%;\r\n    max-width: 400px;\r\n    text-align: center;\r\n    backdrop-filter: blur(10px);\r\n}\r\n\r\n.login-header {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.header-text {\r\n    color: #6c757d;\r\n    font-size: 28px;\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.sub-text {\r\n    color: #6c757d;\r\n    font-size: 14px;\r\n}\r\n\r\n.login-form {\r\n    text-align: left;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.login-form .label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    font-weight: bold;\r\n}\r\n\r\n.login-form .input {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ced4da;\r\n    border-radius: 10px;\r\n    box-sizing: border-box;\r\n    font-size: 16px;\r\n}\r\n\r\n.login-button {\r\n    background: linear-gradient(to right, #ff7e5f, #feb47b);\r\n    color: #ffffff;\r\n    padding: 12px 20px;\r\n    border: none;\r\n    border-radius: 50px;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.login-footer {\r\n    margin-top: 20px;\r\n    font-size: 14px;\r\n    color: #6c757d;\r\n}\r\n\r\n.link {\r\n    color: #ff7e5f;\r\n}\r\n\r\n.error-text {\r\n    color: #850101;\r\n}\r\n\r\n/* Sidebar Expanded */\r\n.container-xxl {\r\n    display: flex;\r\n}\r\n\r\n.container-xxl .content {\r\n    flex-grow: 1;\r\n    margin-left: 250px;\r\n    /* Adjust this based on your sidebar width */\r\n    transition: margin-left 1s ease;\r\n}\r\n\r\n/* Sidebar Collapsed (Sidebar Hidden) */\r\n.sidebar-collapsed .content {\r\n    margin-left: 0;\r\n    width: 100%;\r\n    transition: margin-left 1s ease, width 1s ease;\r\n}\r\n\r\n.sidebar {\r\n    width: 250px;\r\n    transition: width 1s ease;\r\n}\r\n\r\n/* Hide Sidebar */\r\n.sidebar-collapsed .sidebar {\r\n    width: 0;\r\n    overflow: hidden;\r\n    transition: width 1s ease;\r\n}\r\n\r\n.padding-4 {\r\n    padding: 2rem 3rem;\r\n    margin-top: 0;\r\n}\r\n\r\nnav.navbar.navbar-expand-lg.navbar-dark.bg-color {\r\n    /* background: #FFDED2; */\r\n    background: #ffffff;\r\n}\r\n\r\nnav.navbar.navbar-expand-lg.navbar-dark.bg-color ul li a.active {\r\n    color: #00a1d5;\r\n}\r\n\r\nnav.navbar.navbar-expand-lg.navbar-dark.bg-color ul li a {\r\n    color: #000000;\r\n    font-weight: 500;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
